import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from "axios";
import {setCookie} from "../../utils/cookie";
import { getAccessToken } from "../../utils/tokenStore";

const URL_API = process.env.URL_API;

export interface ResetResult {
    data: any[];
}

export const updateNotificationsMobileNumber = createAsyncThunk(
    'supplier/update-notifications-mobile-number',
    async (params: any, {rejectWithValue}) => {

        const updateURL = `${URL_API}/supplier-portal/${params.supplierID}/notifications-mobile-number`;

        try {
            const {data} = await axios.put<ResetResult>(updateURL, params.data, {
                headers: {
                    'Authorization': `Bearer ${getAccessToken()}`
                }
            });

            return data;

        } catch (error) {
            // @ts-ignore
            return rejectWithValue(error.response.data)
        }
    }
);